import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess, UtilService} from "library";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey} from "projects/store/src/app/enums";

@Component({
  selector: 'app-commission-reports-payments',
  templateUrl: './commission-reports-payments.component.html',
  styleUrls: ['./commission-reports-payments.component.scss']
})
export class CommissionReportsPaymentsComponent implements OnInit{
  listPaymentsOfUser: any;

  userData: UserData;
  @Input() year!: number;
  @Input() month!: number;
  @Output() onListPayments = new  EventEmitter<any>

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              protected utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
  }

  ngOnInit() {
    this.load();
  }
  load(){
    this.utilService.enablePageLoading();
    this.commissionsService.getPaymentsOfUser(this.userData.user.id, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok){
          this.listPaymentsOfUser = resp.body.data.list;
          this.onListPayments.emit(this.listPaymentsOfUser);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }
}
